export default "__VITE_ASSET__8FmzQzVO__"